import Button from '@blocks/Button'
import Tab from '@blocks/Filter/Tab'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import useSalon from '@general/models/Salon'
import useTitle from '@hooks/useTitle'
import { route } from '@shared/helpers'
import { Box, Container } from '@styles/helpers'
import { tablet } from '@styles/mixins'
import { grid } from '@styles/vars'
import React from 'react'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import styled, { css } from 'styled-components'
import useAcceptancesQuery from './hooks/useAcceptancesQuery'
import useGalleryArchive from './hooks/useGalleryArchive'

export default function SalonAcceptancesGalleryPage() {
    const { slug, sectionId } = useParams<{ slug: string, sectionId: string | undefined }>()
    const history = useHistory()
    const salon = useSalon(slug)
    const acceptances = useAcceptancesQuery(slug, sectionId)
    const archive = useGalleryArchive(acceptances.data)

    useTitle(`Acceptances Gallery: ${salon.state?.name || "Loading..."}`)

    if (!salon.state) 
        return null

    return (
        <AcceptancesContainer>
            <Grid>
                <Grid gap="20px">
                    <Grid gap="10px">
                        <h1>Acceptances Gallery</h1>
                        <h2 className="h3">{salon.state.name}</h2>
                    </Grid>
                    <Button type="secondary" width="fixed" to={route("general:salon:acceptances", salon.state.slug)}>See Acceptances List</Button>
                </Grid>
                <Box narrow>
                    <Grid gap="20px">
                        <Flex gap="5px" flexWrap='wrap'>
                            <Tab 
                                label="All" 
                                onClick={() => history.push(route("general:salon:acceptances:gallery", salon.state!.slug, null))} 
                                onActiveClick={() => {}} 
                                active={!sectionId} />
                            {salon.state.sections.map(section => 
                                <Tab 
                                    label={section.name}
                                    onClick={() => history.push(route("general:salon:acceptances:gallery", salon.state!.slug, section.id))}
                                    onActiveClick={() => {}}
                                    active={sectionId === section.id.toString()} />
                            )}
                        </Flex>
                        {archive.element}
                    </Grid>
                </Box>
            </Grid>
        </AcceptancesContainer>
    )
}

const NavigationLowWrapper = styled.div`
    margin: 0 -30px 20px;
`

const AcceptancesContainer = styled(Container)`
    padding-top: ${grid.margins.phone};
    padding-bottom: ${grid.margins.phone};

    ${tablet(css`
        padding-top: ${grid.margins.tablet};
        padding-bottom: ${grid.margins.tablet};
    `)}
`